var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#009cde;}.cls-3{fill:#0a74b9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Extra_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_1307",
    "data-name": "Ellisse 1307"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37,
    cy: 37,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,74A37,37,0,1,1,74,37,37,37,0,0,1,37,74ZM37,4A33,33,0,1,0,70,37,33,33,0,0,0,37,4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3092",
    "data-name": "Raggruppa 3092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2088-2",
    "data-name": "Tracciato 2088-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.17,
    y: 18.79,
    width: 2.69,
    height: 35.55
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tracciato_2089",
    "data-name": "Tracciato 2089"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.74,
    y: 35.22,
    width: 35.55,
    height: 2.69
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.48872c9099dfdf161cd7c3d0e5e448cc.svg";
export { ForwardRef as ReactComponent };